<ng-container *ngIf="!loading">
  <div class="p-4 md:p-8">

    <!-- ===== FORM CARD ===== -->
    <div style="max-width: 520px; margin: 0 auto 20px;">
      <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">

        <!-- Header gradient -->
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0;">
          <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #1C593D;">send</mat-icon>
              <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">Enviar USDT</span>
            </div>
            <button type="button" (click)="openCreateDialog()"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 700; font-size: 0.75rem; cursor: pointer; transition: background 0.2s;"
              onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: white;">add</mat-icon>
              Agregar Beneficiario
            </button>
          </div>
        </div>

        <div style="padding: 20px;">

          <!-- Saldo row -->
          <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; margin-bottom: 16px;">
            <div style="display: flex; align-items: center; gap: 6px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">account_balance_wallet</mat-icon>
              <span style="font-size: 0.8rem; font-weight: 600; color: #6b7280;">Saldo disponible</span>
            </div>
            <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f;">{{ formatUSDTWithSymbol(saldoUsdt) }}</span>
          </div>

          <!-- Info: horario (cuando está dentro de horario) -->
          <div *ngIf="isOperatingHours"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">schedule</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Horario de operación: <strong>{{ HORARIO_OPERACION }}</strong></span>
          </div>

          <!-- Error: fuera de horario -->
          <div *ngIf="!isOperatingHours"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">schedule</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">Fuera de horario. Operamos de <strong>{{ HORARIO_OPERACION }}</strong> (hora Chile) — CERRADO</span>
          </div>

          <!-- Warning: saldo insuficiente para mínimo -->
          <div *ngIf="saldoUsdt < MIN_USDT_AMOUNT"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">Tu saldo es inferior al monto mínimo de envío (<strong>{{ MIN_USDT_AMOUNT }} USDT</strong>).</span>
          </div>

          <!--
            Redes pausadas: sus beneficiarios se ven en la lista pero no se
            pueden elegir. Queda fija (no es el banner que se autoborra) hasta
            que la red vuelva.
          -->
          <div *ngIf="avisoRedes" role="status"
            style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #fffbeb; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #b45309; margin-top: 1px;">pause_circle</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #92400e; line-height: 1.45;">{{ avisoRedes }}</span>
          </div>

          <!-- Warning: sin beneficiarios -->
          <div *ngIf="listaCuentas.length === 0"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #92400e;">No tienes beneficiarios registrados. <strong>Agrega uno</strong> para continuar.</span>
          </div>

          <!-- Success message -->
          <div *ngIf="errorMessage && errorMessage.includes('✅')"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-left: 4px solid #16a34a; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">check_circle</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #166534;">{{ errorMessage }}</span>
          </div>

          <!-- Error message -->
          <div *ngIf="errorMessage && !errorMessage.includes('✅')"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626;">error</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">{{ errorMessage }}</span>
          </div>

          <!-- Input USDT amount -->
          <div style="margin-bottom: 16px;">
            <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">Monto a enviar (USDT)</label>
            <div style="position: relative;">
              <span style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #1e5a3f; font-weight: 700; font-size: 0.82rem; pointer-events: none; z-index: 2;">$ USDT</span>
              <!-- `type=text` + `appMonto`: separador de miles en vivo (ver
                   nota en `convert-usdt-clp`). -->
              <input type="text" inputmode="numeric" appMonto [decimales]="2"
                [(ngModel)]="montoAEnviar"
                (ngModelChange)="validateAmount()"
                placeholder="0"
                [disabled]="!isOperatingHours"
                class="calc-input"
                style="width: 100%; padding: 14px 80px 14px 78px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 1.1rem; font-weight: 700; color: #1e5a3f; background: white; text-align: right; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
                onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
              <button type="button" (click)="setMaxAmount()"
                [disabled]="!isOperatingHours"
                [style.opacity]="!isOperatingHours ? '0.5' : '1'"
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: #1C593D; color: white; border: none; border-radius: 8px; padding: 4px 12px; font-size: 0.75rem; font-weight: 700; cursor: pointer; transition: background 0.2s;"
                onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                MÁX
              </button>
            </div>
            <span style="display: block; margin-top: 6px; font-size: 0.75rem; color: #6b7280;">
              Mínimo {{ MIN_USDT_AMOUNT }} USDT — Máximo {{ formatUSDT(saldoUsdt) }} USDT
            </span>
            <span *ngIf="montoAEnviar > 0 && montoAEnviar < MIN_USDT_AMOUNT"
              style="display: block; margin-top: 4px; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              El monto mínimo de envío es {{ MIN_USDT_AMOUNT }} USDT
            </span>
          </div>

          <!-- Select beneficiary -->
          <div style="margin-bottom: 16px;">
            <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">Seleccionar beneficiario</label>
            <select
              #beneficiarioSelect
              class="select-aguacate"
              (change)="onBeneficiarioChange($event)"
              [disabled]="!isOperatingHours || listaCuentas.length === 0"
              style="width: 100%; padding: 14px 40px 14px 16px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.9rem; font-weight: 500; color: #1e5a3f; background-color: white; outline: none; cursor: pointer; transition: border-color 0.2s; box-sizing: border-box;"
              onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
              <option value="">-- Seleccione un beneficiario --</option>
              <option *ngFor="let cuenta of listaCuentas" [value]="cuenta.beneficiario_id" [disabled]="pausado(cuenta)">
                {{ cuenta.beneficiario_nombre }} {{ cuenta.beneficiario_apellido }} · {{ etiquetaRed(cuenta) }}{{ pausado(cuenta) ? ' — Red pausada' : '' }}
              </option>
            </select>
          </div>

          <!-- Verificando la wallet -->
          <div *ngIf="verificandoWallet"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; margin-bottom: 16px;">
            <mat-spinner diameter="16"></mat-spinner>
            <span style="font-size: 0.78rem; font-weight: 500; color: #374151;">Verificando la direcci&oacute;n...</span>
          </div>

          <!--
            Aviso de wallet bloqueada. NO usa `errorMessage`: ese banner se
            autoborra a los 5-10 segundos y este tiene que quedar hasta que el
            cliente elija otro beneficiario.
          -->
          <div *ngIf="walletBloqueada"
            style="display: flex; align-items: flex-start; gap: 8px; padding: 12px 14px; background: #fef2f2; border: 1px solid #fecaca; border-left: 4px solid #dc2626; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #dc2626; margin-top: 2px;">block</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #991b1b;">{{ mensajeBloqueoWallet }}</span>
          </div>

          <!-- Wallet address -->
          <div *ngIf="beneficiarioSeleccionado" style="margin-bottom: 16px;">
            <label style="display: block; font-size: 0.8rem; font-weight: 600; color: #1e5a3f; margin-bottom: 6px;">
              Dirección wallet ({{ beneficiarioSeleccionado.medioCriptomoneda_descripcion }})
            </label>
            <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 12px 16px;">
              <span style="font-family: monospace; font-size: 0.82rem; color: #374151; word-break: break-all;">
                {{ beneficiarioSeleccionado.beneficiario_medio_recepcion }}
              </span>
            </div>
          </div>

          <!--
            Polygon y Solana no los paga Binance: el retiro queda para que un
            operador lo pague a mano. Se avisa antes de enviar, para que el
            cliente sepa que no es inmediato.
          -->
          <div *ngIf="pagoManual" role="status"
            style="display: flex; align-items: flex-start; gap: 8px; padding: 10px 14px; background: #eff6ff; border: 1px solid #bfdbfe; border-left: 4px solid #2563eb; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #2563eb; margin-top: 1px;">schedule</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #1e3a8a; line-height: 1.45;">
              Los retiros por {{ redSeleccionada?.etiqueta }} los paga un operador a mano, en horario de operación. Pueden tardar más que un envío por Tron (TRC20); te avisamos por correo cuando se complete.
            </span>
          </div>

          <!-- Fee summary -->
          <div *ngIf="beneficiarioSeleccionado && montoAEnviar >= MIN_USDT_AMOUNT"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #16a34a;">check_circle</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 500; color: #1e5a3f;">Beneficiario recibirá <strong>{{ formatUSDTWithSymbol(montoAEnviar) }}</strong></span>
          </div>

          <!-- Send button -->
          <button type="button" [disabled]="!canSend()" (click)="sendWithdrawal()"
            [style.opacity]="!canSend() ? '0.5' : '1'"
            [style.cursor]="!canSend() ? 'not-allowed' : 'pointer'"
            style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s;"
            onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-spinner *ngIf="isConverting" diameter="18" class="button-spinner"></mat-spinner>
            <mat-icon *ngIf="!isConverting" style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
            {{ isConverting ? 'Enviando...' : 'Enviar USDT' }}
          </button>

          <!-- Back button -->
          <button type="button" (click)="navigateBack()"
            style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 12px; margin-top: 10px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.88rem; cursor: pointer; transition: background 0.2s;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
            Volver
          </button>

        </div>
      </div>
    </div>

    <!-- ===== HISTORY CARD ===== -->
    <div style="max-width: 900px; margin: 0 auto;">
      <div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden;">

        <!-- Header gradient -->
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">history</mat-icon>
            <span style="font-size: 0.95rem; font-weight: 700; color: #1e5a3f;">Historial de Retiros USDT</span>
          </div>
        </div>

        <div style="padding: 16px 20px;">

          <!-- Blocked balance warning -->
          <div *ngIf="blockedBalance > 0"
            style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef3c7; border: 1px solid #fde68a; border-left: 4px solid #f59e0b; border-radius: 10px; margin-bottom: 16px;">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0; color: #f59e0b;">warning</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 600; color: #92400e;">
              Saldo pendiente de envío: <strong>{{ blockedBalance | currency: 'USD':'symbol':'1.2-2' }}</strong>
            </span>
          </div>

          <!-- Loading -->
          <div *ngIf="loadingHistory" style="text-align: center; padding: 30px;">
            <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
            <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando historial...</p>
          </div>

          <!-- Desktop table -->
          <div *ngIf="!loadingHistory && withdrawalHistory.length > 0" class="hidden lg:block" style="overflow-x: auto;">
            <table class="history-table">
              <thead>
                <tr>
                  <th>Fecha Solicitud</th>
                  <th>Monto</th>
                  <th>Wallet</th>
                  <th>Red</th>
                  <th>Estado</th>
                  <th>TxID</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let withdrawal of withdrawalHistory">
                  <td>{{ withdrawal.requestedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                  <td style="font-weight: 700; color: #1e5a3f;">{{ withdrawal.requestedAmount | currency: 'USD':'symbol':'1.2-2' }}</td>
                  <td style="font-family: monospace; font-size: 0.78rem; word-break: break-all; max-width: 200px;">{{ withdrawal.walletAddress }}</td>
                  <td>{{ withdrawal.network }}</td>
                  <td>
                    <span style="padding: 3px 10px; border-radius: 12px; font-size: 0.7rem; font-weight: 700;"
                      [style.background]="getStatusBg(withdrawal.status)"
                      [style.color]="getStatusColor(withdrawal.status)">
                      {{ getStatusText(withdrawal.status) }}
                    </span>
                  </td>
                  <td style="font-family: monospace; font-size: 0.78rem; word-break: break-all; max-width: 180px;">
                    <span *ngIf="withdrawal.binanceTxId" [title]="withdrawal.binanceTxId">{{ withdrawal.binanceTxId }}</span>
                    <span *ngIf="!withdrawal.binanceTxId" style="color: #9ca3af;">—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile cards -->
          <div *ngIf="!loadingHistory && withdrawalHistory.length > 0" class="lg:hidden"
            style="display: flex; flex-direction: column; gap: 10px;">
            <div *ngFor="let withdrawal of withdrawalHistory; let i = index"
              style="border: 2px solid; border-radius: 12px; overflow: hidden; transition: all 0.2s;"
              [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

              <!-- Card header -->
              <div (click)="toggleCard(i)"
                style="display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; cursor: pointer;"
                [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
                <div style="display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0;">
                  <span style="padding: 3px 10px; border-radius: 12px; font-size: 0.7rem; font-weight: 700; flex-shrink: 0;"
                    [style.background]="getStatusBg(withdrawal.status)"
                    [style.color]="getStatusColor(withdrawal.status)">
                    {{ getStatusText(withdrawal.status) }}
                  </span>
                  <span style="font-size: 0.9rem; font-weight: 700; color: #1e5a3f;">
                    {{ withdrawal.requestedAmount | currency: 'USD':'symbol':'1.2-2' }}
                  </span>
                </div>
                <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #6b7280; transition: transform 0.2s;"
                  [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
                  expand_more
                </mat-icon>
              </div>

              <!-- Card body -->
              <div *ngIf="expandedCardId === i" style="padding: 0 14px 14px; border-top: 1px solid #e5e7eb;">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 12px;">
                  <div>
                    <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Fecha</span>
                    <p style="font-size: 0.82rem; font-weight: 600; color: #374151; margin: 2px 0 0;">
                      {{ withdrawal.requestedAt | date: 'dd/MM/yyyy HH:mm' }}
                    </p>
                  </div>
                  <div>
                    <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Red</span>
                    <p style="font-size: 0.82rem; font-weight: 600; color: #374151; margin: 2px 0 0;">{{ withdrawal.network }}</p>
                  </div>
                </div>
                <div style="margin-top: 10px;">
                  <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">Wallet</span>
                  <p style="font-family: monospace; font-size: 0.78rem; color: #374151; margin: 2px 0 0; word-break: break-all;">
                    {{ withdrawal.walletAddress }}
                  </p>
                </div>
                <div *ngIf="withdrawal.binanceTxId" style="margin-top: 10px;">
                  <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase;">TxID</span>
                  <p style="font-family: monospace; font-size: 0.78rem; color: #374151; margin: 2px 0 0; word-break: break-all;">
                    {{ withdrawal.binanceTxId }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- No history -->
          <div *ngIf="!loadingHistory && withdrawalHistory.length === 0"
            style="text-align: center; padding: 30px 16px; border: 2px dashed #e5e7eb; border-radius: 12px;">
            <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #d1d5db; margin-bottom: 8px;">history</mat-icon>
            <p style="font-size: 0.9rem; font-weight: 600; color: #1e5a3f; margin: 0 0 4px;">No tienes retiros registrados</p>
          </div>

          <!-- Pagination -->
          <div *ngIf="!loadingHistory && withdrawalHistory.length > 0 && totalPages > 0"
            style="display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap; margin-top: 16px;">
            <button type="button" [disabled]="currentPage <= 1" (click)="onPageChange(1)"
              [style.opacity]="currentPage <= 1 ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">first_page</mat-icon>
            </button>
            <button type="button" [disabled]="currentPage <= 1" (click)="onPageChange(+currentPage - 1)"
              [style.opacity]="currentPage <= 1 ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">chevron_left</mat-icon>
            </button>
            <span style="font-size: 0.78rem; font-weight: 600; color: #374151; padding: 0 8px;">
              Página {{ currentPage }} de {{ totalPages }} ({{ totalItems }} retiros)
            </span>
            <button type="button" [disabled]="currentPage >= totalPages" (click)="onPageChange(+currentPage + 1)"
              [style.opacity]="currentPage >= totalPages ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">chevron_right</mat-icon>
            </button>
            <button type="button" [disabled]="currentPage >= totalPages" (click)="onPageChange(totalPages)"
              [style.opacity]="currentPage >= totalPages ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; transition: background 0.2s;"
              onmouseover="if(!this.disabled)this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">last_page</mat-icon>
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
</ng-container>
